import axios from 'axios';
import { API_BASE } from './apiConfig';

// Raw SQL-column-aliased lookup — PascalCase keys, same convention as the other /api/lookups/* routes.
export const getSports = () =>
  axios.get(`${API_BASE}/api/lookups/sports`, { withCredentials: true }).then((r) => r.data);

// The club/country/association/board a Personality represents.
export const getEntities = () =>
  axios.get(`${API_BASE}/api/lookups/entities`, { withCredentials: true }).then((r) => r.data);

// Personality is a reusable, entity-owned record — not scoped to a single event. These routes
// are flat (not space-scoped in the URL); SpaceId is passed inside the create/update payload,
// which the caller derives from the current space context (never a user-picked value).
export const getPersonalitiesByEntity = (entityId) =>
  axios.get(`${API_BASE}/api/entities/${entityId}/personalities`, { withCredentials: true }).then((r) => r.data);

export const getPersonalityById = (id) =>
  axios.get(`${API_BASE}/api/personality/${id}`, { withCredentials: true }).then((r) => r.data);

export const createPersonality = (data) =>
  axios.post(`${API_BASE}/api/personality`, data, { withCredentials: true }).then((r) => r.data);

export const updatePersonality = (id, data) =>
  axios.put(`${API_BASE}/api/personality/${id}`, data, { withCredentials: true }).then((r) => r.data);
